export const inr = (n, dec = 0) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: dec,
    maximumFractionDigits: dec,
  }).format(Number(n) || 0);

export const inrShort = (n) => {
  const v = Number(n) || 0;
  const a = Math.abs(v);
  if (a >= 1e7) return `₹${(v / 1e7).toFixed(2)} Cr`;
  if (a >= 1e5) return `₹${(v / 1e5).toFixed(2)} Lakh`;
  if (a >= 1e3) return `₹${(v / 1e3).toFixed(1)}K`;
  return inr(v);
};

export const inrAxis = (n) => {
  const v = Number(n) || 0;
  const a = Math.abs(v);
  if (a >= 1e7) return `₹${(v / 1e7).toFixed(1)}Cr`;
  if (a >= 1e5) return `₹${(v / 1e5).toFixed(1)}L`;
  if (a >= 1e3) return `₹${(v / 1e3).toFixed(0)}K`;
  return `₹${v}`;
};

export const pct = (n, dec = 2) => `${((Number(n) || 0) * 100).toFixed(dec)}%`;

export const fmtDate = (d) => {
  if (!d) return "—";
  return new Intl.DateTimeFormat("en-IN", { day: "2-digit", month: "short", year: "numeric", timeZone: "Asia/Kolkata" }).format(new Date(d));
};

export const fmtDateTime = (d) => {
  if (!d) return "—";
  return new Intl.DateTimeFormat("en-IN", {
    day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: "Asia/Kolkata",
  }).format(new Date(d)) + " IST";
};

export const gainClass = (n) => (Number(n) >= 0 ? "text-emerald-400" : "text-red-400");

export const kycBadge = (status) => {
  const map = {
    Verified: "bg-emerald-500/10 text-emerald-300 border-emerald-500/25",
    "Under Review": "bg-amber-500/10 text-amber-300 border-amber-500/25",
    Submitted: "bg-sky-500/10 text-sky-300 border-sky-500/25",
    Pending: "bg-white/5 text-zinc-400 border-white/10",
    Rejected: "bg-red-500/10 text-red-400 border-red-500/25",
    "Not Applicable": "bg-white/[0.03] text-zinc-600 border-white/[0.06]",
  };
  return map[status] || map.Pending;
};

export const txnBadge = (status) => {
  const map = {
    Completed: "bg-emerald-500/10 text-emerald-300 border-emerald-500/25",
    Pending: "bg-amber-500/10 text-amber-300 border-amber-500/25",
    Failed: "bg-red-500/10 text-red-400 border-red-500/25",
  };
  return map[status] || map.Pending;
};

export const riskBadge = (risk) => {
  const map = {
    Conservative: "bg-sky-500/10 text-sky-300 border-sky-500/25",
    Growth: "bg-emerald-500/10 text-emerald-300 border-emerald-500/25",
    Prestige: "bg-violet-500/10 text-violet-300 border-violet-500/25",
  };
  return map[risk] || "bg-white/5 text-zinc-400 border-white/10";
};

export const clientStatusBadge = (s) => {
  const map = {
    Active: "bg-emerald-500/10 text-emerald-300 border-emerald-500/25",
    Inactive: "bg-white/5 text-zinc-400 border-white/10",
    "On Hold": "bg-amber-500/10 text-amber-300 border-amber-500/25",
    Suspended: "bg-red-500/10 text-red-400 border-red-500/25",
    Closed: "bg-red-500/10 text-red-400 border-red-500/25",
  };
  return map[s] || map.Active;
};

export const priorityBadge = (p) => {
  const map = {
    Low: "bg-white/5 text-zinc-400 border-white/10",
    Medium: "bg-sky-500/10 text-sky-300 border-sky-500/25",
    High: "bg-amber-500/10 text-amber-300 border-amber-500/25",
    Urgent: "bg-red-500/10 text-red-400 border-red-500/25",
  };
  return map[p] || map.Medium;
};

export const requestStatusBadge = (s) => {
  const map = {
    Open: "bg-emerald-500/10 text-emerald-300 border-emerald-500/25",
    "In Progress": "bg-sky-500/10 text-sky-300 border-sky-500/25",
    "Waiting for Information": "bg-amber-500/10 text-amber-300 border-amber-500/25",
    Resolved: "bg-violet-500/10 text-violet-300 border-violet-500/25",
    Closed: "bg-white/5 text-zinc-500 border-white/10",
  };
  return map[s] || map.Open;
};

export const clientReqBadge = (s) => {
  const map = {
    Pending: "border-amber-500/25 bg-amber-500/10 text-amber-300",
    "In Review": "border-sky-500/25 bg-sky-500/10 text-sky-300",
    Approved: "border-emerald-500/25 bg-emerald-500/10 text-emerald-300",
    Completed: "border-emerald-500/25 bg-emerald-500/10 text-emerald-300",
    Rejected: "border-red-500/25 bg-red-500/10 text-red-400",
  };
  return map[s] || map.Pending;
};
